/**
 * Bejelentkezés feature szövegei
 *
 * Namespace: login
 */
export const login = {
  // Oldal
  page: {
    title: "Bejelentkezés",
    subtitle: "Jelentkezz be a folytatáshoz",
    noAccount: "Nincs még fiókod?",
    createAccount: "Regisztrálj",
    forgotPassword: "Elfelejtett jelszó?",
  },

  // Űrlap mezők
  form: {
    emailLabel: "Email cím",
    emailPlaceholder: "te@example.com",
    passwordLabel: "Jelszó",
    passwordPlaceholder: "••••••••",
    rememberMe: "Emlékezz rám",
    submitButton: "Bejelentkezés",
    loadingButton: "Bejelentkezés...",
  },

  // Külső bejelentkezés (External IDP)
  external: {
    divider: "Vagy folytasd a következővel",
    kreta: "Bejelentkezés Kréta fiókkal",
    loadingButton: "Átirányítás...",
  },

  // Hibák
  errors: {
    recaptchaFailed: "reCAPTCHA ellenőrzés sikertelen. Kérjük, próbáld újra.",
    invalidCredentials:
      "Helytelen email cím vagy jelszó. Kérjük, ellenőrizd az adatokat és próbáld újra.",
  },

  // Sikeres bejelentkezés
  success: {
    title: "Sikeres bejelentkezés",
    message: "Sikeresen bejelentkeztél. Bezárhatod ezt az ablakot.",
  },
} as const;

export type LoginMessages = typeof login;
